import React from "react";
import Edit from "./Edit";
import Overview from "./Overview";
export const Footer = () => {
  return (
    
      <Overview />
    
  );
};

export const EditFooter = () => {
  return (
    
      <Edit />
    
  );
};
